<template>
    <a :href="mainButton.url"
       class="relative rounded-md text-md px-3 py-1 focus:outline-none font-medium transition duration-300 ease-in-out z-30 hover:text-brand"
       :class="[isSelected ? 'text-brand' : 'text-gray-600']"
       @mouseover="showDropdown = true"
       @mouseleave="showDropdown = false">
        <span class="flex items-center gap-2 justify-center py-2">
            <!--<i class="align-middle text-xl mr-1 lg:inline" :class="mainButton.mdi"></i>-->
            <icon-email v-if="iconSelection === 'inbox'" class="w-5 h-5"></icon-email>
            <icon-hammer-and-wrench v-if="iconSelection === 'maintenance'" class="w-5 h-5"></icon-hammer-and-wrench>
            <icon-clipboard-document-list v-if="iconSelection === 'inspections'" class="w-5 h-5"></icon-clipboard-document-list>
            <icon-home v-if="iconSelection === 'data'" class="w-5 h-5"></icon-home>
            <icon-presentation-chart-line v-if="iconSelection === 'reporting'" class="w-5 h-5"></icon-presentation-chart-line>

            <span>{{ mainButton.text }}</span>
        </span>

        <div class="origin-top-left absolute left-0 w-56 z-30" v-if="showDropdown && subButtons.length > 0">
            <div class="bg-white mt-2 rounded-md shadow-xl" style="border-top: 3px solid rgb(226, 27, 34);">
                <div v-for="(subButton, index) in subButtons">
                    <a :href="subButton.url"
                       class="w-full outline-none border-none whitespace-nowrap text-sm text-gray-700 font-normal text-left hover:font-medium hover:bg-indigo-100 hover:text-indigo-600 block px-4 py-2 text-sm transition duration-300"
                       :class="index === 0 ? 'rounded-t-md' : ((index + 1)  === subButtons.length ? 'rounded-b-md' : '')">
                        {{ subButton.text }}
                    </a>
                </div>
            </div>
        </div>
    </a>
</template>

<script>
export default {
    name: "TopNavButton",

    props: {
        iconSelection: {
            required: false,
            type: String,
            Description: "Specify which icon should display"
        },
        mainButton: {
            required: true,
            type: Object,
            Description: "The main button text and url"
        },
        subButtons: {
            required: true,
            type: Array,
            Description: "An Array of sub buttons which will each have a text and url",
        },
        isSelected: {
            required: true,
            type: Boolean,
            Description: "Is the current main button selected"
        }
    },

    data () {
        return {
            showDropdown: false,
        };
    },
};
</script>

<style scoped>

</style>
